import { useState } from 'react';
import { FormControl, Stack, FormLabel, Box } from '@chakra-ui/react';
import { Field } from 'formik';
import { usePartnerForm } from '../../hooks/usePartnerForm';
import NameField from '@/components/forms/new/formikFormFields/NameField';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import { FORM_FIELD_PATHS } from '../../constants';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
} from 'components/forms/new/formStyles';

const HostHeader = ({ darkMode, errors, touched }) => {
    const [isHovered, setIsHovered] = useState(false);
    const { formData, updateFormData } = usePartnerForm();

    const handleChange = (e) => {
        updateFormData(FORM_FIELD_PATHS.HOST_HEADER, e.target.value);
    };

    const hasError = !!errors?.hostHeader && touched?.hostHeader;

    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={hasError}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack direction="row" spacing={stackSpacing} align="center" sx={stackStyling()}>
                <FormLabel sx={formLabelStyling(darkMode, true)}>
                    Host Header
                </FormLabel>
                <Box flex={1} maxWidth="400px">
                    <Field
                        component={NameField}
                        id={FORM_FIELD_PATHS.HOST_HEADER}
                        name={FORM_FIELD_PATHS.HOST_HEADER}
                        value={formData?.[FORM_FIELD_PATHS.HOST_HEADER] || ''}
                        onChange={handleChange}
                        placeholder="partner.example.com"
                        width="100%"
                        darkMode={darkMode}
                        isInvalid={hasError}
                        validate={() => {
                            const value = formData?.[FORM_FIELD_PATHS.HOST_HEADER];
                            if (value && /:|\//.test(value)) {
                                return 'Host header cannot contain protocol (http://) or port numbers';
                            }
                        }}
                    />
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="Custom domain for partner portal (do not include http:// or https://)"
                        ariaLabel="host-header-tip"
                        left="25px"
                        top="5px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default HostHeader;
